module.exports = __webpack_public_path__ + "static/media/SF-18-A.5705e304.mp3";